import { render, staticRenderFns } from "./SyncButton.vue?vue&type=template&id=1e51e85b&"
import script from "./SyncButton.vue?vue&type=script&lang=js&"
export * from "./SyncButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports